import React, { useEffect } from 'react';
import {
  Box,
  TextField,
  Button,
  DialogActions,
  DialogContent,
  IconButton,
} from '@mui/material';
import { observer, useLocalObservable } from 'mobx-react-lite';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { PhotoCamera } from '@mui/icons-material';
import { action } from 'mobx';
import md5 from 'md5';
import { FireSafetyEntryWithImage } from '../../types/transport';

const AdddFireDialog = observer(
  ({
    open,
    fireSafetyItem,
    onClose,
    onSave,
  }: {
    open: boolean;
    fireSafetyItem: FireSafetyEntryWithImage | undefined;
    onClose: () => void;
    onSave: (
      fireSafetyItem: FireSafetyEntryWithImage,
      image: File,
      oldTitle: string,
    ) => void;
  }): JSX.Element => {
    const formData = useLocalObservable(() => ({
      identificationKey: '',
      description: '',
      descriptionStrength: '',
      image: new File([], ''),
      imageURL: '',
      imageFileName: '',
    }));

    const oldTitle = fireSafetyItem?.title || '';

    useEffect(() => {
      formData.identificationKey = fireSafetyItem?.title || '';
      formData.description = fireSafetyItem?.description || '';
      formData.descriptionStrength = fireSafetyItem?.descriptionThickness || '';
      formData.imageURL = fireSafetyItem?.localImageUrl || '';
      formData.imageFileName = fireSafetyItem?.imageFileName || '';
    }, [fireSafetyItem]);

    const handleClose = () => {
      onClose();
    };

    const saveEntry = () => {
      const entry: FireSafetyEntryWithImage = {
        title: formData.identificationKey,
        titleMd5: md5(formData.identificationKey),
        description: formData.description,
        descriptionThickness: formData.descriptionStrength,
        imageFileName: formData.imageFileName,
        localImageUrl: formData.imageURL,
      };

      onSave(entry, formData.image, oldTitle);
    };

    const captureFile: React.ChangeEventHandler<HTMLInputElement> = async ({
      target: input,
    }) => {
      if (input.files) {
        formData.imageURL = URL.createObjectURL(input.files[0]);

        const [inputFile] = Array.from(input.files);
        formData.imageURL = URL.createObjectURL(inputFile);
        formData.imageFileName = inputFile.name;
        formData.image = inputFile;
      }
    };

    return (
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Neue Brandschutz Kategorie erstellen</DialogTitle>
        <DialogContent>
          <TextField
            sx={{ marginTop: 2, marginBottom: 2 }}
            id="identificationKey"
            label="Identifikations-Key"
            helperText="Der Identifikations-Key muss ident zum Key im CSV sein."
            margin="dense"
            fullWidth
            variant="standard"
            value={formData.identificationKey}
            onChange={action(e => {
              formData.identificationKey = e.target.value;
            })}
          />
          <TextField
            sx={{ marginTop: 2, marginBottom: 2 }}
            id="title"
            label="Kategoriebeschreibung"
            margin="dense"
            fullWidth
            variant="standard"
            value={formData.description}
            onChange={action(e => {
              formData.description = e.target.value;
            })}
          />
          <TextField
            sx={{ marginTop: 2, marginBottom: 2 }}
            id="desc"
            label="Beschreibung Stärke"
            margin="dense"
            multiline
            variant="standard"
            rows={2}
            fullWidth
            helperText="2. Detail-Auswahlscreen Text"
            value={formData.descriptionStrength}
            onChange={action(e => {
              formData.descriptionStrength = e.target.value;
            })}
          />
          <Box sx={{ marginTop: 2, marginBottom: 2 }}>
            <label htmlFor="upload">
              Bild hinzufügen
              <input
                accept="image/*"
                id="upload"
                type="file"
                hidden
                onChange={captureFile}
              />
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="span"
              >
                <PhotoCamera />
              </IconButton>
              {formData.imageURL && (
                <img
                  alt="Community Post"
                  src={formData.imageURL}
                  style={{ maxWidth: '300px', display: 'block' }}
                />
              )}
            </label>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Abbrechen</Button>
          <Button onClick={saveEntry}>Speichern</Button>
        </DialogActions>
      </Dialog>
    );
  },
);

export default AdddFireDialog;
